import { createAlbumRequest } from 'reactApp/modules/albums/albums.actions';
import { store as reduxStore } from 'reactApp/store';

export const createAlbum = () => {
    reduxStore.dispatch(createAlbumRequest());
};
